import React, { useState, useCallback, useEffect } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import TopNav from '../TopNav/TopNav';
import AppsNav from './AppsNav';
import SaveBanner from '../JobDetailPage/Mechanical/SaveBanner';
import BookingsLog from './BookingsLog/BookingsLog';
import ActivityLog from './ActivityLog/ActivityLog';
import TaskManagerDashboard from './ActivityLog/TaskManagerDashboard';
import SalesTargets from './BookingsLog/SalesTargets';
import './AppsContainer.css';

const MOBILE_VIEWPORT_QUERY = '(max-width: 767.98px)';

const AppsContainer = () => {
  const location = useLocation();
  const [isMobileViewport, setIsMobileViewport] = useState(() => {
    if (typeof window === 'undefined') return false;
    return window.matchMedia(MOBILE_VIEWPORT_QUERY).matches;
  });
  
  // Shared save notification state
  const [showSaveNotification, setShowSaveNotification] = useState(false);
  const [saveStatus, setSaveStatus] = useState('');

  useEffect(() => {
    const mediaQuery = window.matchMedia(MOBILE_VIEWPORT_QUERY);
    const handleViewportChange = (event) => setIsMobileViewport(event.matches);

    mediaQuery.addEventListener('change', handleViewportChange);
    return () => mediaQuery.removeEventListener('change', handleViewportChange);
  }, []);
  
  // Helper function to show save notifications that can be shared with child components
  const showSaveNotificationMessage = useCallback((message) => {
    setSaveStatus(message);
    setShowSaveNotification(true);
    setTimeout(() => {
      setShowSaveNotification(false);
    }, 3000);
  }, []);
  
  // Determine which component to render based on the current path
  const renderCurrentComponent = () => {
    const path = location.pathname;
    
    if (path.includes('/apps/bookingslog')) {
      return <BookingsLog showSaveNotificationMessage={showSaveNotificationMessage} />;
    } else if (path.includes('/apps/taskmanager')) {
      if (isMobileViewport) {
        return <Navigate to="/apps/activitylog" replace />;
      }
      return <TaskManagerDashboard />;
    } else if (path.includes('/apps/activitylog')) {
      return <ActivityLog showSaveNotificationMessage={showSaveNotificationMessage} />;
    } else if (path.includes('/apps/salesTargets')) {
      return <SalesTargets showSaveNotificationMessage={showSaveNotificationMessage} />;
    }
    
    // Default apps home page content
    return (
      <div className="container-fluid mt-4">
        <div className="row">
          <div className="col-12">
            <h2>Apps Portal</h2>
            <p>Select an application from the navigation above.</p>
          </div>
        </div>
      </div>
    );
  };
  
  // Determine the active key for AppsNav based on current path
  const getActiveKey = () => {
    const path = location.pathname;
    if (path.includes('/apps/bookingslog')) return 'bookingslog';
    if (path.includes('/apps/taskmanager')) return 'taskManager';
    if (path.includes('/apps/activitylog')) return 'activityLog';
    if (path.includes('/apps/salesTargets')) return 'salesTargets';
    return 'home';
  };
  
  return (
    <>
      {/* Top Navigation - stays at the top */}
      <TopNav />
      
      {/* Save Banner - shows above content when notifications are active */}
      <SaveBanner 
        showNotification={showSaveNotification} 
        saveStatus={saveStatus} 
      />
      
      {/* Apps Navigation - stays persistent */}
      <AppsNav keyValue={getActiveKey()} />
      
      {/* Dynamic Content Area - only this section re-renders */}
      <div className="apps-content-container">
        {renderCurrentComponent()}
      </div>
    </>
  );
};

export default AppsContainer;
